import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoExitOutline } from "react-icons/io5";

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light px-2">
      <ul className="navbar-nav d-flex align-items-center justify-content-between w-100">
        <li className="nav-item">
          <Link className="nav-link" data-widget="pushmenu" to="#" role="button">
            <i className="fas fa-bars" />
          </Link>
        </li>
        <li className="nav-item">
          <button className='btn btn-danger ' onClick={handleLogout}>
            <span className='pe-2'>Logout</span>
            <IoExitOutline className='fs-5' />
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
